export default __webpack_public_path__ + "static/media/Screenshot_14.0319634e.png";